<div class="h-100 mx-auto image-container" [ngClass]="customClass">
  <div class="border-secondary border bg-color rounded-3">
    <div class="px-1 mb-0">
      <div class="mb-0 mt-3 px-1">
        <h3 class="text-white px-1 fonts headingFont">
          Delivering Proactive Care and
        </h3>
        <h3 class="text-white px-1 fonts headingFont">
          Seamless Communication with
        </h3>
        <h3 class="text-black px-1 fonts headingFont">
          <span style="color: #212121 !important"> Caregenix.</span>
        </h3>
      </div>
    </div>
    <div class="d-flex justify-content-center caregenix-logo mb-4">
      <img
        src="assets/caregenix/images/logo/png-bg-carevanve-logo.png"
        height="220"
      />
      <div
        [ngClass]="
          screenType == 'userType'
            ? 'cover-medicalStaffUserType'
            : 'cover-medicalStaff'
        "
      >
        <img src="assets/caregenix/images/medical-staff.png" height="230" />
      </div>
    </div>

    <div class="outer-logo">
      <img
        src="assets/caregenix/images/logo/png-favi-carvance.png"
        class="logo-light"
      />
    </div>
  </div>
</div>
